export default "__VITE_ASSET__7f3e1e1e__"